import React from 'react'
import { useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Button } from '../root/components/common'
import { useTomPicturesFilters } from '../root/hooks/use-tom-pictures-filters'
import { PicturesList } from '../tom/components/pictures-list'
import { useLocationPictures } from '../tom/hooks/useLocationPictures'

const TOM_LANDING_PAGE = 'https://www.traplinked.com/tom/'

function LocationPictures(props) {
    const locationId = props.match.params.locationId
    const { locale } = useSelector(state => state.main)
    const { filters, setFilters } = useTomPicturesFilters()
    const {
        data,
        fetchNextPage,
        hasNextPage,
        isLoading,
        isFetching,
        isFetchingNextPage
    } = useLocationPictures(locationId, filters)

    return (
        <PicturesList
            queryKey={`locationPictures-${locationId}`}
            data={data}
            fetchNextPage={fetchNextPage}
            hasNextPage={hasNextPage}
            isLoading={isLoading}
            isFetching={isFetching}
            isFetchingNextPage={isFetchingNextPage}
            filters={filters}
            setFilters={setFilters}
        />
    )
}

export default withRouter(LocationPictures)
